import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/translation/new/[[...args]]/page.tsx")